<div></div>
<div>
    <div *ngIf="isErrorOccured" class="center-align">
      <pershing-message  displayType="inpage" messageType="error" message="{{'RQST_NOT_PROCESSED' | translate}}">
      </pershing-message>
    </div>
</div>